// CourseDetail.jsx - نسخه کامل با رفرش خودکار پس از مارک واچ

import { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import "../styles/coursedetail.css";
import pic from "../images/pic.jpg";
import YoutubeVideoPlayer from "../components/YoutubeVideoPlayer";
import api from "./api";
import video from "../images/play-video.png";
import wifi from "../images/wifi-connection.png";
import alertico from "../images/alert.png";
import upload from "../images/upload.png";
import eye from "../images/eyes.png";
import upload2 from "../images/upload-file.png";
import download from "../images/play.png";
import star from "../images/star.png";
import lockIcon from "../images/padlock.png";
import pause from '../images/pause-button.png';
import TicketButton from './TicketButton';

const API_BASE = "https://api.pythonteek.com";

// تابع تبدیل متن با خطوط جدید به HTML
const formatTextWithNewLines = (text) => {
    if (!text) return "";
    return text.split('\n').map((line, index) => (
        <span key={index}>
            {line}
            <br />
        </span>
    ));
};

const CourseDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [openIndex, setOpenIndex] = useState(0);
    const contentRefs = useRef([]);

    // State های مودال تمرین
    const [showModal, setShowModal] = useState(false);
    const [selectedExercise, setSelectedExercise] = useState(null);
    const [exerciseText, setExerciseText] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [showGuideModal, setShowGuideModal] = useState(false);

    // مودال برای درس‌های قفل شده
    const [showLockModal, setShowLockModal] = useState(false);
    const [lockedLessonTitle, setLockedLessonTitle] = useState("");

    // مودال خطای دسترسی - نیاز به خرید
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [accessError, setAccessError] = useState("");

    // مودال هشدار برای جلو رفتن در درس قفل شده
    const [showNextLessonLockModal, setShowNextLessonLockModal] = useState(false);

    // State برای ویدیوی جاری
    const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
    const [playingLessonId, setPlayingLessonId] = useState(null);
    const [currentLessonTitle, setCurrentLessonTitle] = useState("");
    const [lessonSegments, setLessonSegments] = useState([]);

    const [courseDetail, setCourseDetail] = useState(null);
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentLessonId, setCurrentLessonId] = useState(null);
    const syllabusRef = useRef(null);
    const aboutCourseRef = useRef(null);
    const whyThisCourseRef = useRef(null);
    const aboutTeacherRef = useRef(null);
    const courseContentRef = useRef(null);
    const [purchasing, setPurchasing] = useState(false);
    const videoPlayerRef = useRef(null);

    // ========== STATE برای مسیرهای آموزشی ==========
    const [learningPaths, setLearningPaths] = useState([]);
    const [learningPathsLoading, setLearningPathsLoading] = useState(false);
    const previousCoursesRef = useRef(null);

    // ========== STATE جدید برای مدیریت پخش خودکار ==========
    const [allLessons, setAllLessons] = useState([]);
    const [isAutoPlaying, setIsAutoPlaying] = useState(false);
    
    // ========== STATE برای قفل بودن درس بعدی ==========
    const [nextLessonLocked, setNextLessonLocked] = useState(false);

    // توابع مدیریت مودال ستاره
    const [showStarModal, setShowStarModal] = useState(false);
    const [earnedStars, setEarnedStars] = useState(0);
    const [lessonTitleForStar, setLessonTitleForStar] = useState("");
    const [remainingStars, setRemainingStars] = useState(0);

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const closeSuccessModal = () => {
        setShowSuccessModal(false);
        setSuccessMessage("");
    };

    const closeStarModal = () => {
        setShowStarModal(false);
        setEarnedStars(0);
        setLessonTitleForStar("");
        setRemainingStars(0);
    };

    // تابع نمایش مودال ستاره
    const showStarEarnedModal = (stars, lessonTitle, remainingStar) => {
        setEarnedStars(stars);
        setLessonTitleForStar(lessonTitle);
        setRemainingStars(remainingStar);
        setShowStarModal(true);
    };

    // باز کردن مودال قفل
    const openLockModal = (lessonTitle) => {
        setLockedLessonTitle(lessonTitle);
        setShowLockModal(true);
    };

    const closeLockModal = () => {
        setShowLockModal(false);
        setLockedLessonTitle("");
    };

    // توابع مدیریت مودال خطای دسترسی
    const showAccessErrorModal = (errorMessage) => {
        setAccessError(errorMessage);
        setShowAccessModal(true);
    };

    const closeAccessModal = () => {
        setShowAccessModal(false);
        setAccessError("");
    };

    // ========== توابع مودال هشدار درس بعدی قفل ==========
    const showLockModalForNextLesson = () => {
        setShowNextLessonLockModal(true);
    };

    const closeNextLessonLockModal = () => {
        setShowNextLessonLockModal(false);
    };

    // ========== تابع دریافت اطلاعات درس با segments ==========
    const fetchLessonDetail = async (lessonId) => {
        if (!lessonId) return;
        
        try {
            const response = await api.get(`/pre_student/api/v1/lesson/${lessonId}/public-detail/`);
            if (response.status === 200) {
                const data = response.data;
                setLessonSegments(data.segments || []);
                setCurrentLessonTitle(data.title || "");
            }
        } catch (error) {
            console.error("Error fetching lesson detail:", error);
            setLessonSegments([]);
        }
    };

    // ========== تابع دریافت مسیرهای آموزشی ==========
    const fetchLearningPaths = async () => {
        if (!id) return;

        try {
            setLearningPathsLoading(true);
            const response = await api.get(`/pre_student/api/v1/learning-paths/by-package/${id}/`);
            
            if (response.status === 200) {
                const data = response.data;
                setLearningPaths(data.learning_paths || []);
            }
        } catch (error) {
            console.error("Error fetching learning paths:", error);
            setLearningPaths([]);
        } finally {
            setLearningPathsLoading(false);
        }
    };

    // ========== تابع پیدا کردن اولین درس دیده نشده ==========
    const findFirstUnwatchedLesson = (chaptersData, watchedCount) => {
        let lessonCounter = 0;
        
        for (const chapter of chaptersData) {
            for (const lesson of (chapter.lessons || [])) {
                lessonCounter++;
                if (lessonCounter > watchedCount) {
                    return {
                        lessonId: lesson.id,
                        videoUrl: lesson.video_url,
                        isLocked: lesson.is_locked,
                        title: lesson.title,
                        chapterIndex: chaptersData.indexOf(chapter),
                        lessonIndex: (chapter.lessons || []).indexOf(lesson)
                    };
                }
            }
        }
        return null;
    };

    // ========== تابع پیدا کردن درس بعدی ==========
    const findNextLesson = (currentLessonId) => {
        const currentIndex = allLessons.findIndex(l => l.id === currentLessonId);
        if (currentIndex === -1) return null;
        
        const nextLesson = allLessons[currentIndex + 1];
        if (!nextLesson) return null;
        
        return nextLesson;
    };

    // ========== تابع بررسی اینکه آیا درس بعدی قفل است ==========
    const isNextLessonLocked = (currentLessonId) => {
        if (!currentLessonId) return false;
        
        const currentIndex = allLessons.findIndex(l => l.id === currentLessonId);
        if (currentIndex === -1) return false;
        
        const nextLesson = allLessons[currentIndex + 1];
        if (!nextLesson) return false;
        
        return nextLesson.is_locked === true;
    };

    // ========== تابع بررسی آخرین درس ==========
    const isLastLesson = (lessonId) => {
        if (!lessonId || !allLessons.length) return false;
        const lastLesson = allLessons[allLessons.length - 1];
        return lastLesson?.id === lessonId;
    };

    // ========== تابع اسکرول به مسیرهای آموزشی ==========
    const scrollToPreviousCourses = () => {
        setTimeout(() => {
            if (previousCoursesRef.current) {
                previousCoursesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    };

    // ========== تابع پخش درس بعدی (بدون اسکرول) ==========
    const playNextLesson = () => {
        if (!currentLessonId) return;
        
        const nextLesson = findNextLesson(currentLessonId);
        
        if (!nextLesson || nextLesson.is_locked) return;
        
        if (nextLesson.video_url) {
            let foundChapterIndex = -1;
            let foundLessonIndex = -1;
            
            for (let i = 0; i < faqData.length; i++) {
                const lessonIdx = (faqData[i].lessons || []).findIndex(l => l.id === nextLesson.id);
                if (lessonIdx !== -1) {
                    foundChapterIndex = i;
                    foundLessonIndex = lessonIdx;
                    break;
                }
            }
            
            if (foundChapterIndex !== -1) {
                setOpenIndex(foundChapterIndex);
            }
            
            handleVideoChange(nextLesson.video_url, nextLesson.id, nextLesson.is_locked, nextLesson.title);
        }
    };

    const autoPlayPreviewForPaidCourse = () => {
        if (courseDetail?.has_purchased === false && courseDetail?.price !== 0 && courseDetail?.price !== null && courseDetail?.price !== undefined) {
            const previewUrl = courseDetail?.preview_video_url || courseDetail?.first_lesson_video_url;
            
            if (previewUrl) {
                const fullUrl = getFullUrl(previewUrl);
                setCurrentVideoUrl(fullUrl);
                setCurrentLessonId(null);
                setPlayingLessonId(null);
                setCurrentLessonTitle("ویدیو مقدماتی");
                setLessonSegments([]);
            }
        }
    };

    // ========== تابع پخش خودکار درس بعد از دیده نشده ==========
    const autoPlayNextLesson = (chaptersData, watchedCount) => {
        if (courseDetail?.has_purchased === false && courseDetail?.price !== 0 && courseDetail?.price !== null && courseDetail?.price !== undefined) {
            autoPlayPreviewForPaidCourse();
            return;
        }
        
        if (!chaptersData || chaptersData.length === 0) return;
        
        if (courseDetail?.has_purchased === false) return;
        
        if (watchedCount >= courseDetail?.lessons_count) return;

        const nextLesson = findFirstUnwatchedLesson(chaptersData, watchedCount);
        
        if (nextLesson && nextLesson.videoUrl && !nextLesson.isLocked) {
            const fullUrl = getFullUrl(nextLesson.videoUrl);
            setCurrentVideoUrl(fullUrl);
            setCurrentLessonId(nextLesson.lessonId);
            setPlayingLessonId(nextLesson.lessonId);
            
            fetchLessonDetail(nextLesson.lessonId);
            
            const nextLocked = isNextLessonLocked(nextLesson.lessonId);
            setNextLessonLocked(nextLocked);
            
            if (nextLesson.chapterIndex !== undefined) {
                setOpenIndex(nextLesson.chapterIndex);
            }
        }
    };

    // ========== اسکرول به بالای صفحه هنگام لود شدن ==========
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        fetchCourseData();
        fetchLearningPaths();

        const hasSeenGuide = localStorage.getItem("exerciseGuideSeen");

        if (!hasSeenGuide) {
            setTimeout(() => {
                setShowGuideModal(true);
            }, 1000);
        }
    }, [id]);

    // ========== به‌روزرسانی nextLessonLocked هنگام تغییر currentLessonId ==========
    useEffect(() => {
        if (currentLessonId) {
            const nextLocked = isNextLessonLocked(currentLessonId);
            setNextLessonLocked(nextLocked);
        }
    }, [currentLessonId, allLessons]);

    // ========== تابع رفتن به صفحه جزئیات دوره ==========
    const goToCourseDetail = (courseId) => {
        if (courseId) {
            navigate(`/course-detail/${courseId}`);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        }
    };

    const closeGuideModal = () => {
        localStorage.setItem("exerciseGuideSeen", "true");
        setShowGuideModal(false);
    };

    const openUploadModal = (exercise) => {
        console.log("Opening modal for exercise:", exercise);
        console.log("Exercise ID:", exercise.id);
        setSelectedExercise(exercise);
        setShowModal(true);
    };

    const closeUploadModal = () => {
        setShowModal(false);
        setSelectedExercise(null);
        setExerciseText("");
        setSelectedFile(null);
        setUploading(false);
    };

    // تابع handle ارسال تمرین
    const handleSubmitExercise = async () => {
        if (!selectedExercise) {
            alert("اطلاعات تمرین یافت نشد.");
            return;
        }

        if (!exerciseText.trim() && !selectedFile) {
            alert("لطفاً حداقل یک توضیح یا فایل برای تمرین وارد کنید.");
            return;
        }

        setUploading(true);

        const formData = new FormData();
        if (exerciseText.trim()) {
            formData.append('description', exerciseText);
        }
        if (selectedFile) {
            formData.append('answer_file', selectedFile);
        }

        try {
            const response = await api.post(
                `/pre_student/api/v3/exercises-submit/${selectedExercise.id}/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                if (response.data.message) {
                    setSuccessMessage(response.data.message);
                } else {
                    setSuccessMessage("تمرینت با موفقیت رسید! 🎉");
                }
                setShowSuccessModal(true);
                closeUploadModal();
            }
        } catch (error) {
            console.error("Error submitting exercise:", error);

            if (error.response?.data?.error) {
                alert(error.response.data.error);
            } else if (error.response?.data?.message) {
                alert(error.response.data.message);
            } else if (error.response?.status === 401) {
                alert(" لطفاً ابتدا وارد حساب کاربری خود شوید.");
            } else {
                alert("خطا در ارسال تمرین. لطفاً دوباره تلاش کنید.");
            }
        } finally {
            setUploading(false);
        }
    };

    // ========== تابع handleVideoChange اصلاح شده ==========
    const handleVideoChange = (videoUrl, lessonId, isLocked, lessonTitle) => {
        if (courseDetail?.has_purchased === false && courseDetail?.price !== 0 && courseDetail?.price !== null && courseDetail?.price !== undefined) {
            showAccessErrorModal(
                "🎯 برای دسترسی به این درس، ابتدا باید دوره رو تهیه کنی! 🚀"
            );
            return;
        }

        if (isLocked) {
            openLockModal(lessonTitle);
            return;
        }

        if (videoUrl) {
            const fullUrl = getFullUrl(videoUrl);
            setCurrentVideoUrl(fullUrl);
            setCurrentLessonId(lessonId);
            setPlayingLessonId(lessonId);
            setCurrentLessonTitle(lessonTitle || "");
            
            fetchLessonDetail(lessonId);
            
            const nextLocked = isNextLessonLocked(lessonId);
            setNextLessonLocked(nextLocked);
        }
    };

    const handlePurchase = async () => {
        if (!id) return;

        setPurchasing(true);

        try {
            const response = await api.post('/pre_student/api/v3/purchase/initiate/', {
                package_id: parseInt(id)
            });

            if (response.status === 200 || response.status === 201) {
                const data = response.data;

                if (data.message && data.message.includes("با موفقیت به دوره")) {
                    window.alert(" دوره با موفقیت به دوره‌های شما اضافه شد!");
                    await fetchCourseData();
                    return;
                }

                if (data.payment_url) {
                    window.location.href = data.payment_url;
                    return;
                }

                if (data.error) {
                    alert(` ${data.error}`);
                } else {
                    alert("خطا در فرآیند خرید. لطفاً مجدداً تلاش کنید.");
                }
            }

        } catch (error) {
            console.error("Purchase error:", error);

            if (error.response?.data?.error) {
                if (error.response.data.error === "شما قبلاً این پکیج را خریداری کرده‌اید.") {
                    alert("ℹ️ شما قبلاً این دوره را خریداری کرده‌اید!");
                    await fetchCourseData();
                } else {
                    alert(`❌ ${error.response.data.error}`);
                }
            }
            else if (error.response?.status === 401) {
                alert("❌ لطفاً ابتدا وارد حساب کاربری خود شوید.");
                navigate('/login');
            }
            else {
                alert("❌ خطا در اتصال به سرور. لطفاً مجدداً تلاش کنید.");
            }
        } finally {
            setPurchasing(false);
        }
    };

    const toggleFAQ = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    const scrollToWhyThisCourse = () => {
        whyThisCourseRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const scrollToSyllabus = () => {
        syllabusRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const scrollToAboutCourse = () => {
        aboutCourseRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const scrollToCourseContent = () => {
        whyThisCourseRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const scrollToAboutTeacher = () => {
        aboutTeacherRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    
    const scrollToPreviousCoursesManual = () => {
        previousCoursesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const goBack = () => {
        navigate(-1);
    };

    const getFullUrl = (url) => {
        if (!url) return "";
        if (url.startsWith("http")) return url;
        return `${API_BASE}${url}`;
    };

    const toPersianNumber = (value) => {
        if (value === null || value === undefined) return "";
        return String(value).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
    };

    // ========== تابع refreshCourseData برای به‌روزرسانی اطلاعات دوره ==========
    const refreshCourseData = async () => {
        if (!id) return;

        try {
            setLoading(true);

            const [detailRes, chaptersRes] = await Promise.all([
                api.get(`/pre_student/api/v3/package-detail/${id}/`),
                api.get(`/pre_student/api/v3/package-chapters/${id}/`)
            ]);

            const detailData = detailRes?.data || null;
            const chaptersData = chaptersRes?.data?.chapters || [];

            setCourseDetail(detailData);

            let lessonCounter = 0;
            const allLessonsList = [];

            const mappedFaqData = chaptersData.map((chapter, chapterIndex) => {
                const lessons = (chapter.lessons || []).map((lesson, lessonIndex) => {
                    lessonCounter += 1;
                    
                    allLessonsList.push({
                        ...lesson,
                        chapterIndex: chapterIndex,
                        lessonIndex: lessonIndex,
                        displayNumber: toPersianNumber(String(lessonIndex + 1).padStart(2, "0")),
                        is_free: lessonCounter <= 5
                    });

                    return {
                        ...lesson,
                        displayNumber: toPersianNumber(String(lessonIndex + 1).padStart(2, "0")),
                        is_free: lessonCounter <= 5
                    };
                });

                return {
                    id: chapter.id || chapterIndex,
                    question: `فصل ${toPersianNumber(chapterIndex + 1)} - `,
                    answer: chapter.title || "",
                    minutes: chapter.duration_minutes || "",
                    lessons
                };
            });

            setAllLessons(allLessonsList);
            setFaqData(mappedFaqData);

            // به‌روزرسانی وضعیت قفل درس بعدی
            if (currentLessonId) {
                const nextLocked = isNextLessonLocked(currentLessonId);
                setNextLessonLocked(nextLocked);
            }

            return { detailData, chaptersData, mappedFaqData };

        } catch (error) {
            console.log("Error refreshing course data:", error);
            return null;
        } finally {
            setLoading(false);
        }
    };

    // ========== تابع fetchCourseData ==========
    const fetchCourseData = async () => {
        if (!id) return;

        try {
            setLoading(true);

            const [detailRes, chaptersRes] = await Promise.all([
                api.get(`/pre_student/api/v3/package-detail/${id}/`),
                api.get(`/pre_student/api/v3/package-chapters/${id}/`)
            ]);

            const detailData = detailRes?.data || null;
            const chaptersData = chaptersRes?.data?.chapters || [];

            setCourseDetail(detailData);

            let lessonCounter = 0;
            const allLessonsList = [];

            const mappedFaqData = chaptersData.map((chapter, chapterIndex) => {
                const lessons = (chapter.lessons || []).map((lesson, lessonIndex) => {
                    lessonCounter += 1;
                    
                    allLessonsList.push({
                        ...lesson,
                        chapterIndex: chapterIndex,
                        lessonIndex: lessonIndex,
                        displayNumber: toPersianNumber(String(lessonIndex + 1).padStart(2, "0")),
                        is_free: lessonCounter <= 5
                    });

                    return {
                        ...lesson,
                        displayNumber: toPersianNumber(String(lessonIndex + 1).padStart(2, "0")),
                        is_free: lessonCounter <= 5
                    };
                });

                return {
                    id: chapter.id || chapterIndex,
                    question: `فصل ${toPersianNumber(chapterIndex + 1)} - `,
                    answer: chapter.title || "",
                    minutes: chapter.duration_minutes || "",
                    lessons
                };
            });

            setAllLessons(allLessonsList);
            setFaqData(mappedFaqData);

            if (detailData?.has_purchased === false && detailData?.price !== 0 && detailData?.price !== null && detailData?.price !== undefined) {
                const previewUrl = detailData?.preview_video_url || detailData?.first_lesson_video_url;
                if (previewUrl) {
                    setCurrentVideoUrl(getFullUrl(previewUrl));
                    setCurrentLessonId(null);
                    setPlayingLessonId(null);
                    setCurrentLessonTitle("ویدیو مقدماتی");
                    setLessonSegments([]);
                }
            } else if (detailData?.preview_video_url && detailData?.is_preview) {
                setCurrentVideoUrl(getFullUrl(detailData.preview_video_url));
            }

            if (detailData?.has_purchased !== false && chaptersData.length > 0) {
                const isFreeOrPurchased = detailData?.price === 0 || 
                                          detailData?.price === null || 
                                          detailData?.price === undefined || 
                                          detailData?.has_purchased === true;
                
                if (isFreeOrPurchased) {
                    const watchedCount = detailData?.watched_lessons_count || 0;
                    setTimeout(() => {
                        autoPlayNextLesson(chaptersData, watchedCount);
                    }, 500);
                }
            }

        } catch (error) {
            console.log("course detail error:", error);

            if (error.response?.status === 403 ||
                error.response?.data?.error === "شما به این دوره دسترسی ندارید") {
                showAccessErrorModal(
                    error.response?.data?.error || "شما به این دوره دسترسی ندارید!"
                );
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCourseData();
    }, [id]);

    // ========== استخراج دوره‌های قبلی و بعدی از مسیرهای آموزشی ==========
    const getPreviousAndNextCourses = () => {
        const prevCourses = [];
        const nextCourses = [];

        learningPaths.forEach(path => {
            if (path.previous_step) {
                prevCourses.push({
                    ...path.previous_step,
                    learning_path_title: path.learning_path_title,
                    learning_path_id: path.learning_path_id,
                    id: path.previous_step.id,
                    package: path.previous_step.id,
                    package_title: path.previous_step.title,
                    package_logo: path.previous_step.logo_url,
                });
            }
            if (path.next_step) {
                nextCourses.push({
                    ...path.next_step,
                    learning_path_title: path.learning_path_title,
                    learning_path_id: path.learning_path_id,
                    id: path.next_step.id,
                    package: path.next_step.id,
                    package_title: path.next_step.title,
                    package_logo: path.next_step.logo_url,
                });
            }
        });

        const uniquePrev = [];
        const prevIds = new Set();
        prevCourses.forEach(course => {
            if (!prevIds.has(course.id)) {
                prevIds.add(course.id);
                uniquePrev.push(course);
            }
        });

        const uniqueNext = [];
        const nextIds = new Set();
        nextCourses.forEach(course => {
            if (!nextIds.has(course.id)) {
                nextIds.add(course.id);
                uniqueNext.push(course);
            }
        });

        return { previousCourses: uniquePrev, nextCourses: uniqueNext };
    };

    const { previousCourses, nextCourses } = getPreviousAndNextCourses();
    const hasPreviousCourses = previousCourses.length > 0;
    const hasNextCourses = nextCourses.length > 0;
    const hasAnyCourse = hasPreviousCourses || hasNextCourses;

    // ========== رندر کارت دوره با اندازه ثابت ==========
    const renderCourseCard = (course, type) => {
        const isPrevious = type === 'previous';
        const label = isPrevious ? 'دوره قبلی' : 'دوره بعدی';
        const bgLabel = isPrevious ? '#FFF3E0' : '#E8F5E9';
        const textLabel = isPrevious ? '#E65100' : '#1B5E20';

        const logoUrl = course.logo_url || course.package_logo || null;
        const fullLogoUrl = logoUrl ? (logoUrl.startsWith('http') ? logoUrl : `${API_BASE}${logoUrl}`) : null;
        const courseId = course.id || course.package;

        const handleNavigate = (e) => {
            if (e) e.stopPropagation();
            goToCourseDetail(courseId);
        };

        return (
            <div
                className="course-card"
                style={{
                    position: "relative",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    width: "100%",
                    maxWidth: "380px",
                    margin: "0 auto",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                }}
                onClick={handleNavigate}
            >
                <div
                    style={{
                        position: "absolute",
                        top: "12px",
                        right: "12px",
                        backgroundColor: bgLabel,
                        color: textLabel,
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                        zIndex: 2,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
                    }}
                >
                    {label}
                </div>

                {course.learning_path_title && (
                    <div
                        style={{
                            position: "absolute",
                            top: "12px",
                            left: "12px",
                            backgroundColor: "#E3F2FD",
                            color: "#0D47A1",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "0.65rem",
                            fontWeight: "bold",
                            zIndex: 2,
                            maxWidth: "55%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                         {course.learning_path_title}
                    </div>
                )}

                <div className="all-pic" style={{ height: "180px", overflow: "hidden" }}>
                    {fullLogoUrl ? (
                        <img 
                            src={fullLogoUrl} 
                            alt={course.title || course.package_title} 
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    ) : (
                        <img 
                            src={pic} 
                            alt={course.title || course.package_title} 
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    )}
                </div>
                <div className="not-buy p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="course-title" style={{ fontWeight: "bold", fontSize: "1rem", flex: 1 }}>
                            {course.title || course.package_title}
                        </div>
                    </div>

                    <div className="row mt-1">
                        <div className="col-6" style={{ color: "#666", fontSize: "0.8rem" }}>
                            مدرس: {course.teacher_name || "نامشخص"}
                        </div>
                        <div className="col-6" style={{ color: "#666", fontSize: "0.8rem" }}>
                            {course.duration_hours || 0} ساعت {course.duration_minutes || 0} دقیقه
                        </div>
                        <div className="col-6 mt-1" style={{ color: "#f39c12", fontSize: "0.8rem" }}>
                            <svg width="14" height="14" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "inline", marginLeft: "4px" }}>
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.8236 0.850248L17.83 6.97067C18.0513 7.414 18.4725 7.7246 18.9626 7.79849L25.7084 8.79325C26.1026 8.85208 26.4617 9.06006 26.6993 9.38025C26.9423 9.7018 27.0422 10.1027 26.9841 10.4982C26.9369 10.8238 26.783 11.1289 26.5521 11.3588L21.6625 16.1588C21.3048 16.5009 21.1414 16.9921 21.2251 17.4779L22.4334 24.2345C22.5643 25.0418 22.0324 25.8054 21.2251 25.9709C20.8984 26.0243 20.561 25.9709 20.2653 25.8163L14.2431 22.6364C13.7949 22.4065 13.2684 22.4065 12.8256 22.6364L6.80336 25.8163C6.05817 26.2172 5.13209 25.9394 4.72979 25.2019C4.5786 24.9077 4.52595 24.5711 4.5732 24.2455L5.77873 17.4888C5.86512 17.0085 5.70178 16.5105 5.34268 16.1684L0.453075 11.3739C0.16958 11.0906 0.00488281 10.7061 0.00488281 10.3052C0.00488281 9.90431 0.16958 9.51981 0.453075 9.23658C0.68527 9.00123 0.990365 8.84661 1.32381 8.80419L8.06963 7.80944C8.55832 7.73418 8.97952 7.43042 9.19686 6.98161L12.102 0.850248C12.3545 0.331661 12.8877 0.000532139 13.4736 0.0114786H13.6531C14.1594 0.0757888 14.6022 0.390498 14.8236 0.850248Z"
                                    fill="#FCCB40"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.5103 22.4546C13.2457 22.4546 12.9987 22.5449 12.7611 22.6625L6.76043 25.8329C6.03819 26.201 5.12561 25.9068 4.73007 25.2021C4.57752 24.9134 4.51947 24.5823 4.57212 24.2552L5.779 17.5163C5.85865 17.0238 5.6953 16.5325 5.3416 16.185L0.442546 11.385C-0.147393 10.798 -0.147393 9.84017 0.442546 9.2477C0.674742 9.01782 0.975786 8.86731 1.29708 8.81942L8.06855 7.80961C8.58424 7.73435 8.95954 7.44154 9.19578 6.98179L12.1387 0.780639C12.3601 0.278472 13.1148 -0.0690766 13.5211 0.0116532C13.5103 0.423512 13.5103 22.1823 13.5103 22.4546Z"
                                    fill="#FAC025"
                                />
                            </svg>
                            {course.total_points || 0} ستاره
                        </div>
                       
                    </div>

                    <div className="mt-3">
                        <button
                            onClick={handleNavigate}
                            style={{
                                backgroundColor: "#28a745",
                                color: "#fff",
                                border: "none",
                                padding: "6px 18px",
                                borderRadius: "8px",
                                fontSize: "0.85rem",
                                fontWeight: "500",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                boxShadow: "0 2px 8px rgba(40, 167, 69, 0.3)",
                                width: "100%",
                                justifyContent: "center",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#218838";
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(40, 167, 69, 0.4)";
                                e.currentTarget.style.transform = "translateY(-2px)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#28a745";
                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(40, 167, 69, 0.3)";
                                e.currentTarget.style.transform = "translateY(0)";
                            }}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                            </svg>
                            مشاهده دوره
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ========== رندر بخش دوره‌های قبلی و بعدی ==========
    const renderPreviousCoursesSection = () => {
        if (learningPathsLoading) {
            return (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="success" />
                    <p className="mt-3" style={{ color: "#7e7e7e" }}>در حال دریافت مسیرهای آموزشی...</p>
                </div>
            );
        }

        if (!hasAnyCourse) {
            return null;
        }

        const hasBoth = hasPreviousCourses && hasNextCourses;

        return (
            <div>
                {hasBoth && (
                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-md-6 col-lg-5">
                            {previousCourses.map((course) => (
                                <div key={`prev-${course.id}`}>
                                    {renderCourseCard(course, 'previous')}
                                </div>
                            ))}
                        </div>
                        <div className="col-12 col-md-6 col-lg-5">
                            {nextCourses.map((course) => (
                                <div key={`next-${course.id}`}>
                                    {renderCourseCard(course, 'next')}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {hasPreviousCourses && !hasNextCourses && (
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            {previousCourses.map((course) => (
                                <div key={`prev-${course.id}`}>
                                    {renderCourseCard(course, 'previous')}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {!hasPreviousCourses && hasNextCourses && (
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            {nextCourses.map((course) => (
                                <div key={`next-${course.id}`}>
                                    {renderCourseCard(course, 'next')}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <br/><br/>
            </div>
        );
    };

    return (
        <div className="p-lg-5 px-3 py-3">
            {/* ====== بخش بالای صفحه با عنوان ====== */}
            <div className="d-flex justify-content-between">
                <div className="fs-5 fs-lg-4">
                    <img src={video} width={60} className="mx-3" alt="video" />
                    {courseDetail?.title || ""}
                </div>
                <div onClick={goBack} style={{ cursor: 'pointer' }}>
                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M26.21 9.99978C26.21 10.7581 25.5889 11.3791 24.8305 11.3791H4.69055L10.9317 17.6548C11.4842 18.2072 11.4842 19.0693 10.9317 19.62C10.6907 19.8628 10.3458 20 9.96574 20C9.62087 20 9.24254 19.8628 9.00147 19.5865L0.413073 10.9657C-0.137691 10.4132 -0.137691 9.55115 0.413073 9.0339L9.00147 0.413026C9.55224 -0.137675 10.4144 -0.137675 10.9669 0.413026C11.5177 0.965452 11.5177 1.82754 10.9669 2.37824L4.69055 8.62044H24.8305C25.5889 8.62044 26.21 9.24149 26.21 9.99978Z" fill="#202244" />
                    </svg>
                </div>
            </div>

            {/* ====== بخش پلیر ویدیو ====== */}
            <div className="mt-4 d-flex">
                <YoutubeVideoPlayer
                    ref={videoPlayerRef}
                    src={currentVideoUrl || 
                         getFullUrl(courseDetail?.preview_video_url) || 
                         getFullUrl(courseDetail?.first_lesson_video_url)}
                    className="vid-course rounded"
                    lessonId={currentLessonId}
                    onVideoEnded={async (data) => {
                        console.log("🎬 ویدیو به پایان رسید:", data);
                        
                        if (data.success && data.lesson_id) {
                            // دریافت مجدد اطلاعات دوره برای به‌روزرسانی وضعیت قفل‌ها
                            const result = await refreshCourseData();
                            
                            if (result) {
                                const { chaptersData } = result;
                                const watchedCount = courseDetail?.watched_lessons_count || 0;
                                
                                // پیدا کردن و پخش خودکار درس بعدی
                                const nextLesson = findFirstUnwatchedLesson(chaptersData, watchedCount);
                                
                                if (nextLesson && nextLesson.videoUrl && !nextLesson.isLocked) {
                                    const fullUrl = getFullUrl(nextLesson.videoUrl);
                                    setCurrentVideoUrl(fullUrl);
                                    setCurrentLessonId(nextLesson.lessonId);
                                    setPlayingLessonId(nextLesson.lessonId);
                                    setCurrentLessonTitle(nextLesson.title || "");
                                    
                                    await fetchLessonDetail(nextLesson.lessonId);
                                    
                                    // به‌روزرسانی وضعیت قفل درس بعدی
                                    const nextLocked = isNextLessonLocked(nextLesson.lessonId);
                                    setNextLessonLocked(nextLocked);
                                    
                                    if (nextLesson.chapterIndex !== undefined) {
                                        setOpenIndex(nextLesson.chapterIndex);
                                    }
                                    
                                    // نمایش مودال ستاره اگر امتیازی وجود دارد
                                    if (data.star > 0) {
                                        showStarEarnedModal(data.star, data.lesson_title, data.remaining_star || 0);
                                    }
                                } else if (isLastLesson(currentLessonId)) {
                                    // اگر آخرین درس بود، اسکرول به بخش مسیرهای آموزشی
                                    scrollToPreviousCourses();
                                }
                            }
                        } else if (data.error) {
                            console.warn("⚠️ خطا در ثبت تماشا:", data.error);
                        }
                    }}
                    title={currentLessonTitle || courseDetail?.title || "ویدیو آموزشی"}
                    segments={lessonSegments}
                    autoPlay={true}
                    isLocked={nextLessonLocked}
                    onSeekAttempt={() => {
                        showLockModalForNextLesson();
                    }}
                />
                {/* ====== منوی سمت راست (دسکتاپ) ====== */}
                <div className="d-lg-flex align-items-center d-none px-3 p-relative">
                    <img style={{ position: "absolute", top: "90px", left: "0" }} src={wifi} width={80} className="mx-3" alt="wifi" />

                    <div className="coursed-container">
                        <div className="p-5">
                            <button onClick={scrollToSyllabus} className="course-btn w-100 m-2">
                                سرفصل ها
                            </button>
                            <button onClick={scrollToAboutCourse} className="course-btn w-100 m-2">
                                درباره دوره
                            </button>
                            <button onClick={scrollToCourseContent} className="course-btn w-100 m-2">
                                محتوای دوره
                            </button>
                            <button onClick={scrollToAboutTeacher} className="course-btn w-100 m-2">
                                درباره مدرس
                            </button>
                            <button onClick={scrollToPreviousCoursesManual} className="course-btn w-100 m-2">
                             مسیر های آموزشی
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ====== منوی موبایل ====== */}
            <div>
                <div className="d-block d-lg-none">
                    <div className="py-4 px-2 mobile-scroll-buttons">
                        <button onClick={scrollToSyllabus} className="course-btn upd-sz mx-1">
                            سرفصل ها
                        </button>
                        <button onClick={scrollToAboutCourse} className="course-btn upd-sz mx-1">
                            درباره دوره
                        </button>
                        <button onClick={scrollToCourseContent} className="course-btn upd-sz mx-1">
                            محتوای دوره
                        </button>
                        <button onClick={scrollToAboutTeacher} className="course-btn upd-sz mx-1">
                            درباره مدرس
                        </button>
                        <button onClick={scrollToPreviousCoursesManual} className="course-btn upd-sz mx-1">
                            مسیر های آموزشی
                        </button>
                    </div>
                </div>
            </div>

            {/* ====== سرفصل‌ها ====== */}
            <div ref={syllabusRef} className="m-3 p-3 coursed-container p-relative">
                <img style={{ position: "absolute", top: "-20px", left: "0" }} src={video} width={80} className="mx-3" alt="video" />
                <div className="faq-container">
                    {faqData.map((item, index) => (
                        <div
                            key={item.id || index}
                            className={`faq-item ${openIndex === index ? "open" : ""}`}
                        >
                            <button
                                type="button"
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                                aria-expanded={openIndex === index}
                            >
                                <span>
                                    {item.question} <span style={{ color: "#28a745" }}>{item.answer}</span>
                                </span>

                                <svg
                                    className={`faq-icon ${openIndex === index ? "rotated" : ""}`}
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    {openIndex === index ? (
                                        <path d="M18 15L12 9L6 15" stroke="#202244" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    ) : (
                                        <path d="M6 9L12 15L18 9" stroke="#202244" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    )}
                                </svg>
                            </button>

                            <div className={`faq-answer-wrapper ${openIndex === index ? "open" : ""}`}>
                                <div className="faq-answer">
                                    {(item.lessons || []).map((lesson, lessonIndex) => {
                                        const isPlaying = playingLessonId === lesson.id;
                                        
                                        return (
                                            <div
                                                key={lesson.id || lessonIndex}
                                                id={`lesson-${lesson.id}`}
                                                onClick={() => {
                                                    if (courseDetail?.has_purchased === false) {
                                                        showAccessErrorModal(
                                                            "🎯 برای دسترسی به این درس، ابتدا باید دوره رو تهیه کنی! 🚀"
                                                        );
                                                        return;
                                                    }
                                                    
                                                    if (lesson.video_url && !lesson.is_locked) {
                                                        handleVideoChange(lesson.video_url, lesson.id, lesson.is_locked, lesson.title);
                                                    } else if (lesson.is_locked) {
                                                        handleVideoChange(null, null, lesson.is_locked, lesson.title);
                                                    }
                                                }}
                                                style={{ 
                                                    cursor: (courseDetail?.has_purchased === false || (lesson.video_url && !lesson.is_locked)) 
                                                        ? 'pointer' 
                                                        : 'default',
                                                    backgroundColor: isPlaying ? '#FFF3E0' : 'transparent',
                                                    borderRadius: isPlaying ? '8px' : '0',
                                                    transition: 'background-color 0.3s ease',
                                                    padding: isPlaying ? '4px 0' : '0',
                                                    borderRight: isPlaying ? '4px solid #FF9800' : 'none'
                                                }}
                                            >
                                                <div className="p-lg-2 p-0 d-flex bb-detail justify-content-between">
                                                    <div className="d-flex my-3">
                                                        <div className="number-part">
                                                            {lesson.displayNumber || toPersianNumber(String(lessonIndex + 1).padStart(2, "0"))}
                                                        </div>

                                                        <div className="px-lg-4 px-1 wc-200">
                                                            <div>
                                                                {lesson.title || "عنوان درس"}
                                                            </div>
                                                            <div className="d-flex justify-content-between">
                                                                <div className="fs-little mt-lg-3 mb-lg-2 mb-0 mt-1">
                                                                    {lesson.duration_minutes ? `${toPersianNumber(lesson.duration_minutes)} دقیقه` : ""}
                                                                </div>
                                                                <div className="d-block d-lg-none fs-little mt-1">
                                                                    امتیاز: {toPersianNumber(lesson.stars || 0)} ستاره
                                                                    <svg className="mx-1" width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.5884 0.372859L7.9246 3.05666C8.023 3.25106 8.2102 3.38726 8.428 3.41966L11.4262 3.85586C11.6014 3.88166 11.761 3.97286 11.8666 4.11326C11.9746 4.25426 12.019 4.43006 11.9932 4.60346C11.9722 4.74626 11.9038 4.88006 11.8012 4.98086L9.628 7.08566C9.469 7.23566 9.3964 7.45106 9.4336 7.66406L9.9706 10.6269C10.0288 10.9809 9.7924 11.3157 9.4336 11.3883C9.2884 11.4117 9.1384 11.3883 9.007 11.3205L6.3304 9.92606C6.1312 9.82526 5.8972 9.82526 5.7004 9.92606L3.0238 11.3205C2.6926 11.4963 2.281 11.3745 2.1022 11.0511C2.035 10.9221 2.0116 10.7745 2.0326 10.6317L2.5684 7.66886C2.6068 7.45826 2.5342 7.23986 2.3746 7.08986L0.201397 4.98746C0.0753973 4.86326 0.00219727 4.69466 0.00219727 4.51886C0.00219727 4.34306 0.0753973 4.17446 0.201397 4.05026C0.304597 3.94706 0.440197 3.87926 0.588397 3.86066L3.5866 3.42446C3.8038 3.39146 3.991 3.25826 4.0876 3.06146L5.3788 0.372859C5.491 0.145459 5.728 0.000259327 5.9884 0.00505933H6.0682C6.2932 0.0332593 6.49 0.171259 6.5884 0.372859Z" fill="#FCCB40" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center">
                                                        <div className="d-lg-block d-none mx-3">
                                                            امتیاز: {toPersianNumber(lesson.stars || 0)} ستاره
                                                            <svg className="mx-1" width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.5884 0.372859L7.9246 3.05666C8.023 3.25106 8.2102 3.38726 8.428 3.41966L11.4262 3.85586C11.6014 3.88166 11.761 3.97286 11.8666 4.11326C11.9746 4.25426 12.019 4.43006 11.9932 4.60346C11.9722 4.74626 11.9038 4.88006 11.8012 4.98086L9.628 7.08566C9.469 7.23566 9.3964 7.45106 9.4336 7.66406L9.9706 10.6269C10.0288 10.9809 9.7924 11.3157 9.4336 11.3883C9.2884 11.4117 9.1384 11.3883 9.007 11.3205L6.3304 9.92606C6.1312 9.82526 5.8972 9.82526 5.7004 9.92606L3.0238 11.3205C2.6926 11.4963 2.281 11.3745 2.1022 11.0511C2.035 10.9221 2.0116 10.7745 2.0326 10.6317L2.5684 7.66886C2.6068 7.45826 2.5342 7.23986 2.3746 7.08986L0.201397 4.98746C0.0753973 4.86326 0.00219727 4.69466 0.00219727 4.51886C0.00219727 4.34306 0.0753973 4.17446 0.201397 4.05026C0.304597 3.94706 0.440197 3.87926 0.588397 3.86066L3.5866 3.42446C3.8038 3.39146 3.991 3.25826 4.0876 3.06146L5.3788 0.372859C5.491 0.145459 5.728 0.000259327 5.9884 0.00505933H6.0682C6.2932 0.0332593 6.49 0.171259 6.5884 0.372859Z" fill="#FCCB40" />
                                                            </svg>
                                                        </div>

                                                        {lesson.is_locked ? (
                                                            <img src={lockIcon} width={34} className="" alt="قفل" title="این درس قفل است! اول درس قبلی رو کامل کن" />
                                                        ) : (
                                                            lesson.video_url && (
                                                                playingLessonId === lesson.id ? (
                                                                    <img src={pause} width={25} className="ms-lg-1 ms-0" alt="پخش"  />
                                                                ) : (
                                                                    <img src={download} width={25} className="" alt="پخش" />
                                                                )
                                                            )
                                                        )}
                                                    </div>
                                                </div>

                                                {(lesson.exercises || []).map((ex, exIndex) => (
                                                    <div key={ex.id || exIndex}>
                                                        <div className="p-lg-2 p-0 d-block d-lg-flex bb-detail justify-content-between">
                                                            <div className="d-flex my-3">
                                                                 <div style={{width:"46px"}}>
                                                                <div className="number-part">
                                                                    {toPersianNumber(String(exIndex + 1).padStart(2, "0"))}
                                                                </div>
                                                                </div>
                                                                <div className="px-lg-4 px-1">
                                                                    تمرین
                                                                    <div>{ex.description || "توضیحات تمرین"}</div>
                                                                </div>
                                                            </div>

                                                            <div className="d-flex align-items-center">
                                                                <div className="mx-3">
                                                                    امتیاز: {toPersianNumber(ex.points || 0)} ستاره
                                                                    <svg className="mx-1" width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.5884 0.372859L7.9246 3.05666C8.023 3.25106 8.2102 3.38726 8.428 3.41966L11.4262 3.85586C11.6014 3.88166 11.761 3.97286 11.8666 4.11326C11.9746 4.25426 12.019 4.43006 11.9932 4.60346C11.9722 4.74626 11.9038 4.88006 11.8012 4.98086L9.628 7.08566C9.469 7.23566 9.3964 7.45106 9.4336 7.66406L9.9706 10.6269C10.0288 10.9809 9.7924 11.3157 9.4336 11.3883C9.2884 11.4117 9.1384 11.3883 9.007 11.3205L6.3304 9.92606C6.1312 9.82526 5.8972 9.82526 5.7004 9.92606L3.0238 11.3205C2.6926 11.4963 2.281 11.3745 2.1022 11.0511C2.035 10.9221 2.0116 10.7745 2.0326 10.6317L2.5684 7.66886C2.6068 7.45826 2.5342 7.23986 2.3746 7.08986L0.201397 4.98746C0.0753973 4.86326 0.00219727 4.69466 0.00219727 4.51886C0.00219727 4.34306 0.0753973 4.17446 0.201397 4.05026C0.304597 3.94706 0.440197 3.87926 0.588397 3.86066L3.5866 3.42446C3.8038 3.39146 3.991 3.25826 4.0876 3.06146L5.3788 0.372859C5.491 0.145459 5.728 0.000259327 5.9884 0.00505933H6.0682C6.2932 0.0332593 6.49 0.171259 6.5884 0.372859Z" fill="#FCCB40" />
                                                                    </svg>
                                                                </div>

                                                                <div className="d-flex">
                                                                    {ex.file_url && (
                                                                        <span
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                window.open(`${ex.file_url}`, '_blank');
                                                                            }}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            <img src={eye} width={40} className="mx-1" alt="eye" title="مشاهده فایل تمرین" />
                                                                        </span>
                                                                    )}
                                                                    <span
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            openUploadModal(ex);
                                                                        }}
                                                                        style={{ cursor: 'pointer' }}
                                                                        className="mx-2"
                                                                    >
                                                                        <img src={upload2} width={40} className="mx-1" title="ارسال تمرین" alt="wifi" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    ))}
                    {loading && <div className="p-3">در حال دریافت اطلاعات...</div>}
                </div>
            </div>

            {/* ====== چرا باید این دوره رو تهیه کنی؟ ====== */}
            <div className="p-lg-5 p-2" ref={whyThisCourseRef}>
                <div className="fs-4">چرا باید این دوره رو تهیه کنی؟</div>
                <div className="row py-3 px-lg-5 mx-lg-5">
                    <div className="col-6 col-lg-4 d-flex justify-content-center align-items-center">
                        <svg className="mx-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M17.9191 18.4615C17.9191 18.7469 17.6401 18.9785 17.2961 18.9785H6.17083V4.09846H17.9191V18.4615ZM1.2312 17.9446V3.84615L1.48152 3.95462L1.73091 4.02308H1.81435L2.02758 4.06231H4.93963V18.9785H2.4624C1.7819 18.9723 1.2312 18.5123 1.2312 17.9446ZM2.4624 1.02154H16.369C16.1623 1.33692 16.0538 1.69462 16.0649 2.05538C16.0649 2.41308 16.1808 2.76769 16.3978 3.07692H2.49114C1.85051 3.03154 1.35821 2.58385 1.35821 2.04923C1.35821 1.51462 1.85051 1.07 2.49114 1.02154H2.4624ZM18.5422 3.07692C18.0712 3.11 17.6225 2.92385 17.3759 2.59C17.1292 2.26 17.1292 1.84231 17.3759 1.50846C17.6225 1.17769 18.0712 0.988462 18.5422 1.02154C18.8537 0.991539 19.0854 0.772308 19.0854 0.510769C19.0854 0.252308 18.8537 0.0330769 18.5422 0H2.4624C1.10048 0.00307692 0 0.922308 0 2.05538V17.9446C0 19.0777 1.10048 19.9969 2.4624 20H17.2961C18.3215 20 19.1503 19.3115 19.1503 18.4615V3.59385C19.1503 3.31154 18.8787 3.08 18.5422 3.07692Z" fill="#28a745" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.02519 17.9446H11.1254C11.4369 17.9146 11.6687 17.6954 11.6687 17.4339C11.6687 17.1754 11.4369 16.9562 11.1254 16.9231H8.02519C7.71368 16.9562 7.4819 17.1754 7.4819 17.4339C7.4819 17.6954 7.71368 17.9146 8.02519 17.9446ZM8.02519 15.9016H12.3566C12.7006 15.9016 12.9797 15.67 12.9797 15.3846C12.9797 15.0993 12.7006 14.8677 12.3566 14.8677H8.02519C7.68494 14.8677 7.40588 15.0993 7.40588 15.3846C7.40588 15.67 7.68494 15.9016 8.02519 15.9016ZM8.02519 13.8462H11.1254C11.4369 13.8131 11.6687 13.5939 11.6687 13.3354C11.6687 13.0739 11.4369 12.8546 11.1254 12.8246H8.02519C7.71368 12.8546 7.4819 13.0739 7.4819 13.3354C7.4819 13.5939 7.71368 13.8131 8.02519 13.8462ZM8.64821 7.94464H15.4421V6.40618H8.64821V7.94464ZM8.02499 8.97849H16.0649C16.4088 8.97849 16.6879 8.74695 16.6879 8.46157V5.90157C16.6879 5.61618 16.4088 5.38464 16.0649 5.38464H8.02499C7.68845 5.38772 7.41681 5.61926 7.41681 5.90157V8.46157C7.41681 8.74387 7.68845 8.97234 8.02499 8.97849Z" fill="#28a745" />
                        </svg>
                        <span className="ms-2">{toPersianNumber(courseDetail?.lessons_count || 0)} درس</span>
                    </div>
                    <div className="col-6 col-lg-4 d-flex align-items-center justify-content-center ">
                        <svg className="mx-2" width="27" height="21" viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M4.65108 15.8234L4.01544 17.7764C3.86114 18.2498 4.71879 18.4397 4.87221 17.9685L5.50807 16.0155C5.66148 15.5456 4.80383 15.3527 4.65108 15.8234Z" fill="#28a745" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.98834 9.47592C9.30224 8.1765 12.1625 3.90503 13.46 3.90503C13.7939 3.90503 14.7783 4.01666 15.5778 4.22739C10.3067 8.59024 13.2344 6.17395 5.96776 12.1549C5.85586 12.2464 5.83321 12.3759 5.79347 12.5003C5.57922 12.2464 5.38141 11.8556 5.60165 11.4002C5.98596 10.6057 7.29387 10.1639 7.98834 9.47592ZM20.8767 0.882131L22.5376 2.20034C17.8848 6.02989 19.5326 4.67576 14.8771 8.50679C14.3412 8.52908 12.6898 8.60018 11.4472 8.68308C12.7107 7.64247 10.697 9.30682 20.8767 0.882131ZM17.2178 14.1022C17.2862 13.7308 17.1797 13.2602 17.0296 12.9063C17.3193 12.9019 18.8039 13.4458 19.0963 13.5516C18.5855 13.8568 17.8075 14.0799 17.2178 14.1022ZM13.1338 14.2654C13.6665 13.9331 14.0246 13.4438 14.1347 12.8984L16.0696 12.9142C16.288 13.3351 16.4814 13.8308 16.2301 14.2389C15.5396 15.2852 13.8363 15.2693 13.1338 14.2654ZM8.64418 11.0016C8.74564 11.6139 9.25296 12.3148 9.83486 12.6565L9.18524 13.1905L7.57383 11.8701C8.82024 10.8446 8.49499 11.1066 8.64418 11.0016ZM8.29539 13.9229L6.10296 14.3864L6.67799 12.6075L6.9433 12.3888L8.55471 13.7093L8.29539 13.9229ZM12.3343 13.8165L12.3335 13.8172H12.3326C11.6057 14.1287 10.7161 13.9799 10.1912 13.4582L10.925 12.8543C11.2129 12.8667 11.8295 12.8781 13.2293 12.8904C13.1052 13.2918 12.7793 13.6293 12.3343 13.8165ZM26.1983 20.2616H1.02519L4.11346 10.8669H4.9296C4.30684 11.7751 4.69204 12.758 5.52017 13.3458L5.04927 14.8029C4.96424 15.07 5.25575 15.3253 5.58789 15.2555L8.59023 14.6209C8.68148 14.6095 8.76541 14.5734 8.83046 14.5202L9.5287 13.946C10.1661 14.5647 11.2294 14.9096 12.3454 14.6058C12.8954 15.3909 13.7515 15.7571 14.682 15.7571C15.5214 15.7571 16.3411 15.4197 16.838 14.8259C18.0617 14.9411 19.5699 14.2986 19.9904 13.8798C21.196 14.3208 22.1855 14.8318 26.1931 14.8707H26.1974C26.7819 14.8707 26.7862 14.1396 26.2027 14.1339C20.3112 14.0769 19.9982 12.6313 17.157 12.1564L17.1537 12.1556C16.0964 11.983 12.4376 12.2514 10.8462 12.1133C9.9865 11.9412 9.40904 11.2563 9.52093 10.5497V10.5467C9.63461 9.96739 10.0778 9.57392 10.324 9.52271C10.324 9.52271 14.4522 9.29097 20.5854 8.74055C21.1691 8.68805 21.0727 7.95766 20.4891 8.00813L16.2847 8.38576C18.393 6.65013 19.4571 5.7731 19.6816 5.58816C21.8212 6.04297 26.1974 7.31016 26.1974 7.31016C26.6951 7.31016 26.8148 6.72713 26.3406 6.59266C24.6683 6.11924 22.7232 5.50324 20.4136 4.98505L23.4854 2.45731C23.6892 2.28747 23.6408 2.05279 23.4803 1.92918L21.1769 0.101447C21.0035 -0.0374482 20.7233 -0.0317377 20.5568 0.10642L16.2725 3.65174C15.2752 3.31868 13.8771 3.16818 13.46 3.16818C11.4869 3.16818 8.85399 7.47263 7.30764 9.0025C6.93731 9.36871 6.27037 9.68831 5.67469 10.1301H3.77444C3.57418 10.1301 3.39901 10.2417 3.34595 10.4021L0.0156789 20.5337C-0.020732 20.6444 0.00702023 20.7625 0.091165 20.8539C0.17531 20.9452 0.305412 20.9985 0.444174 20.9985H26.1983C26.7846 20.9985 26.7855 20.2616 26.1983 20.2616Z" fill="#28a745" />
                        </svg>
                        <span className="ms-2">{toPersianNumber(courseDetail?.exercises_count || 0)} تمرین</span>
                    </div>
                    <div className="col-6 mt-3 col-lg-4 d-flex align-items-center justify-content-center ">
                        <svg className="mx-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M17.9191 18.4615C17.9191 18.7469 17.6401 18.9785 17.2961 18.9785H6.17083V4.09846H17.9191V18.4615ZM1.2312 17.9446V3.84615L1.48152 3.95462L1.73091 4.02308H1.81435L2.02758 4.06231H4.93963V18.9785H2.4624C1.7819 18.9723 1.2312 18.5123 1.2312 17.9446ZM2.4624 1.02154H16.369C16.1623 1.33692 16.0538 1.69462 16.0649 2.05538C16.0649 2.41308 16.1808 2.76769 16.3978 3.07692H2.49114C1.85051 3.03154 1.35821 2.58385 1.35821 2.04923C1.35821 1.51462 1.85051 1.07 2.49114 1.02154H2.4624ZM18.5422 3.07692C18.0712 3.11 17.6225 2.92385 17.3759 2.59C17.1292 2.26 17.1292 1.84231 17.3759 1.50846C17.6225 1.17769 18.0712 0.988462 18.5422 1.02154C18.8537 0.991539 19.0854 0.772308 19.0854 0.510769C19.0854 0.252308 18.8537 0.0330769 18.5422 0H2.4624C1.10048 0.00307692 0 0.922308 0 2.05538V17.9446C0 19.0777 1.10048 19.9969 2.4624 20H17.2961C18.3215 20 19.1503 19.3115 19.1503 18.4615V3.59385C19.1503 3.31154 18.8787 3.08 18.5422 3.07692Z" fill="#28a745" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.02519 17.9446H11.1254C11.4369 17.9146 11.6687 17.6954 11.6687 17.4339C11.6687 17.1754 11.4369 16.9562 11.1254 16.9231H8.02519C7.71368 16.9562 7.4819 17.1754 7.4819 17.4339C7.4819 17.6954 7.71368 17.9146 8.02519 17.9446ZM8.02519 15.9016H12.3566C12.7006 15.9016 12.9797 15.67 12.9797 15.3846C12.9797 15.0993 12.7006 14.8677 12.3566 14.8677H8.02519C7.68494 14.8677 7.40588 15.0993 7.40588 15.3846C7.40588 15.67 7.68494 15.9016 8.02519 15.9016ZM8.02519 13.8462H11.1254C11.4369 13.8131 11.6687 13.5939 11.6687 13.3354C11.6687 13.0739 11.4369 12.8546 11.1254 12.8246H8.02519C7.71368 12.8546 7.4819 13.0739 7.4819 13.3354C7.4819 13.5939 7.71368 13.8131 8.02519 13.8462ZM8.64821 7.94464H15.4421V6.40618H8.64821V7.94464ZM8.02499 8.97849H16.0649C16.4088 8.97849 16.6879 8.74695 16.6879 8.46157V5.90157C16.6879 5.61618 16.4088 5.38464 16.0649 5.38464H8.02499C7.68845 5.38772 7.41681 5.61926 7.41681 5.90157V8.46157C7.41681 8.74387 7.68845 8.97234 8.02499 8.97849Z" fill="#28a745" />
                        </svg>
                        <span className="ms-2">گواهینامه</span>
                    </div>
                </div>
            </div>

            {/* ====== درباره دوره ====== */}
            <div ref={aboutCourseRef}>
                <div className="p-lg-5 p-3 about-course p-relative">
                    <div className="fs-4">
                        <img style={{ position: "absolute", top: "-20px", left: "0" }} src={alertico} width={80} className="mx-3" alt="wifi" />
                        درباره دوره
                    </div>
                    <div className="mt-3" style={{ color: "#585858" }}>
                        {formatTextWithNewLines(courseDetail?.description || "")}
                    </div>
                </div>
            </div>

            {/* ====== درباره مدرس ====== */}
            <div className="p-lg-5 p-3" ref={aboutTeacherRef}>
                <div className="fs-4">درباره مدرس</div>
                <div>
                    <div className="d-flex mt-3">
                        <div className="ms-2">
                            <img
                                className="rounded-circle"
                                style={{ border: "3px solid #28a745" }}
                                width={80}
                                height={80}
                                src={`${courseDetail?.teacher_profile_image}`}
                                alt="teacher"
                            />
                        </div>
                        <div>
                            <div className="bold" style={{ fontSize: "18px" }}>
                                {courseDetail?.teacher_name || " "} | {courseDetail?.teacher_position || " "}
                            </div>
                            <div style={{ color: "#7e7e7e" }}>
                                {formatTextWithNewLines(courseDetail?.teacher_bio || "")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ========== بخش مسیرهای آموزشی ========== */}
            {hasAnyCourse && (
                <div ref={previousCoursesRef} className="p-lg-5 p-3 mt-4" style={{ backgroundColor: "#f8f9fa", borderRadius: "16px" }}>
                    <div className="fs-4 mb-4 text-center">
                        <span style={{ display: "inline-flex", alignItems: "center" }}>
                            مسیرهای آموزشی
                        </span>
                        <p style={{ fontSize: "0.9rem", color: "#7e7e7e", marginTop: "8px" }}>
                            دوره‌های قبلی و بعدی این دوره در مسیرهای آموزشی
                        </p>
                    </div>
                    {renderPreviousCoursesSection()}
                </div>
            )}

            {/* ====== مودال‌ها ====== */}
            {/* مودال ارسال تمرین */}
            <Modal
                show={showModal}
                onHide={closeUploadModal}
                centered
                className="custom-exercise-modal"
            >
                <Modal.Body className="p-4" style={{ direction: "ltr" }}>
                    {selectedExercise && (
                        <div className="text-center">
                            <div className="d-flex justify-content-between mb-4">
                                <span onClick={closeUploadModal} style={{ cursor: 'pointer' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 12H5" stroke="#202244" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 19L5 12L12 5" stroke="#202244" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <h5 className="fw-bold">
                                    تمرین خود را ارسال کنید
                                    <img src={upload} width={80} className="me-3" alt="wifi" />
                                </h5>
                                <div style={{ width: 24 }}></div>
                            </div>

                            <p className="text-end mb-3">عکس یا فایل خود را اضافه کنید</p>

                            <div className="upload-box mb-4" onClick={() => document.getElementById('fileInput').click()}>
                                <input type="file" id="fileInput" hidden onChange={(e) => setSelectedFile(e.target.files[0])} />
                                <svg width="63" height="40" viewBox="0 0 63 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M50.8475 16.8332C50.8475 16.6667 50.8751 16.5001 50.8751 16.3336C50.8751 7.30583 43.6806 0 34.8058 0C28.4028 0 22.9025 3.80528 20.3196 9.30556C19.1944 8.73583 17.9308 8.40278 16.5972 8.40278C12.5 8.40278 9.08306 11.4442 8.43042 15.4167C3.51417 17.111 0 21.8196 0 27.3611C0 34.3332 5.56972 40 12.4306 40H26.6667V28.8889H19.9724L31.1111 17.264L42.25 28.8747H35.5556V39.9858H50.8751C57.1528 39.9858 62.2222 34.7775 62.2222 28.4028C62.2222 22.0279 57.1251 16.8474 50.8475 16.8332Z" fill="#2BA769" />
                                </svg>
                                <p>فایل را اینجا بکشید یا کلیک کنید</p>
                                {selectedFile && <p className="text-success mt-2">{selectedFile.name}</p>}
                            </div>

                            <p className="text-end mb-2">تمرین خود را بنویسید</p>
                            <textarea
                                className="form-control mb-4"
                                style={{ direction: "rtl" }}
                                rows={4}
                                placeholder="تایپ کنید..."
                                value={exerciseText}
                                onChange={(e) => setExerciseText(e.target.value)}
                            />

                            <button
                                className="submit-exercise-btn w-100"
                                onClick={handleSubmitExercise}
                                disabled={uploading}
                            >
                                {uploading ? (
                                    "...در حال ارسال"
                                ) : (
                                    <>
                                        <svg className="mx-2" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                            <path d="M19 12H5M12 5L5 12L12 19" />
                                        </svg>
                                        ارسال کردن تمرین
                                    </>
                                )}
                            </button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* مودال قفل درس */}
            <Modal
                show={showLockModal}
                onHide={closeLockModal}
                centered
                className="custom-lock-modal"
            >
                <Modal.Body className="p-4 text-center" style={{ direction: "rtl" }}>
                    <div className="mb-3">
                        <img src={lockIcon} width="80" alt="قفل" />
                    </div>
                    <h5 className="fw-bold mb-3" style={{ color: "#202244" }}>
                        🧸 این درس هنوز قفل داره 🧸
                    </h5>
                    <p className="mb-4" style={{ fontSize: "1.1rem", color: "#585858" }}>
                        برای دیدن درس <strong className="text-success">«{lockedLessonTitle}»</strong>،
                        <br />
                        اول باید <strong className="text-success">درس قبلی رو کامل ببینی</strong> و تمرین‌هاش رو انجام بدی!
                        <br />
                        <span role="img" aria-label="بچه گانه">یه کم صبر کن، به زودی به این درس می‌رسی!</span>
                    </p>
                    <button
                        className="submit-exercise-btn px-4"
                        onClick={closeLockModal}
                        style={{ backgroundColor: "#ff9800", border: "none" }}
                    >
                        باشه فهمیدم 😊
                    </button>
                </Modal.Body>
            </Modal>

            {/* مودال هشدار برای جلو رفتن در درس قفل شده */}
            <Modal
                show={showNextLessonLockModal}
                onHide={closeNextLessonLockModal}
                centered
                className="custom-lock-modal"
            >
                <Modal.Body className="p-4 text-center" style={{ direction: "rtl" }}>
                    <div className="mb-3">
                        <div style={{ fontSize: "4rem" }}>⛔</div>
                    </div>
                    <h5 className="fw-bold mb-3" style={{ color: "#202244" }}>
                        🧸 نمی‌تونی جلو بزنی!
                    </h5>
                    <p className="mb-4" style={{ fontSize: "1.1rem", color: "#585858" }}>
                        <br />
                        برای باز کردنش، اول باید <strong className="text-success">      این ویدیو رو کامل ببینی</strong>!
                        <br /><br />
                        <span role="img" aria-label="بچه گانه">فعلاً فقط می‌تونی به عقب برگردی و دوباره ببینی! 😊</span>
                    </p>
                    <button
                        className="submit-exercise-btn px-4"
                        onClick={closeNextLessonLockModal}
                        style={{ backgroundColor: "#ff9800", border: "none" }}
                    >
                        باشه فهمیدم 😊
                    </button>
                </Modal.Body>
            </Modal>

            {/* مودال خطای دسترسی - نیاز به خرید */}
            <Modal
                show={showAccessModal}
                onHide={closeAccessModal}
                centered
                className="custom-access-modal"
            >
                <Modal.Body className="p-4 text-center" style={{ direction: "rtl" }}>
                    <div className="mb-3">
                        <div style={{ fontSize: "4rem" }}>🔒</div>
                    </div>

                    <h5 className="fw-bold mb-3" style={{ color: "#202244", fontSize: "1.5rem" }}>
                        🙈 اوه! این دوره قفل شده!
                    </h5>

                    <p className="mb-3" style={{ fontSize: "1.1rem", color: "#585858" }}>
                        {accessError || "برای دسترسی به محتوای این دوره، باید فرآیند خرید رو تکمیل کنی!"}
                    </p>

                    <div className="my-3 p-3 rounded-3" style={{ backgroundColor: "#FFF3E0", display: "inline-block" }}>
                        <span style={{ fontSize: "1rem", color: "#E65100" }}>
                            🎯 فقط با یه کلیک به تمام درس‌ها و تمرین‌های این دوره دسترسی پیدا کن!
                        </span>
                    </div>

                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 mt-3">
                        <button
                            className="submit-exercise-btn px-4"
                            onClick={() => {
                                closeAccessModal();
                                handlePurchase();
                            }}
                            style={{ backgroundColor: "#28a745", border: "none" }}
                        >
                            🛒 خرید دوره
                        </button>

                        <button
                            className="submit-exercise-btn px-4"
                            onClick={closeAccessModal}
                            style={{ backgroundColor: "#6c757d", border: "none" }}
                        >
                            بعداً می‌خرم
                        </button>
                    </div>

                    <p className="mt-3" style={{ fontSize: "0.85rem", color: "#a0a0a0" }}>
                        💡 با خرید دوره، به تمام محتواهای آموزشی دسترسی کامل خواهی داشت!
                    </p>
                </Modal.Body>
            </Modal>

            {/* مودال ستاره */}
            <Modal
                show={showStarModal}
                onHide={closeStarModal}
                centered
                className="custom-star-modal"
            >
                <Modal.Body className="p-4 text-center" style={{ direction: "rtl" }}>
                    <img src={star} width="80" alt="ستاره" />
                    <h5 className="fw-bold mb-3" style={{ color: "#202244", fontSize: "1.5rem" }}>
                        آفرین!
                    </h5>

                    <p style={{ fontSize: "1.2rem", color: "#585858" }}>
                        تو درس <strong className="text-success">«{lessonTitleForStar}»</strong> رو با موفقیت دیدی!
                    </p>

                    <div className="my-3 p-3 rounded-3" style={{ backgroundColor: "#FFF3E0", display: "inline-block" }}>
                        <span style={{ fontSize: "2rem", fontWeight: "bold", color: "#FF9800" }}>
                            ⭐ {earnedStars} ستاره
                        </span>
                    </div>

                    <p style={{ fontSize: "1rem", color: "#7e7e7e" }}>
                        {earnedStars >= 10 ? " خیلی عالی! به این راحتی‌ها نبوغ داری؟!" :
                            earnedStars >= 5 ? "  همینطوری ادامه بده !" :
                                " قدم اول رو محکم برداشتی! به همون راه ادامه بده!"}
                    </p>

                    <p className="mt-2" style={{ fontSize: "0.9rem", color: "#28a745" }}>
                        🚀 فقط {remainingStars} ستاره دیگه مونده تا به دوره بعدی برسی!
                    </p>

                    <button
                        className="submit-exercise-btn px-5 mt-3"
                        onClick={closeStarModal}
                        style={{ backgroundColor: "#28a745", border: "none" }}
                    >
                        ادامه می‌دم!
                    </button>
                </Modal.Body>
            </Modal>

            {/* مودال موفقیت ارسال تمرین */}
            <Modal
                show={showSuccessModal}
                onHide={closeSuccessModal}
                centered
                className="custom-success-modal"
            >
                <Modal.Body className="p-4 text-center" style={{ direction: "rtl" }}>
                    <div className="mb-3">
                        <div style={{ fontSize: "4rem" }}>
                            <img src={star} width="80" alt="star" />
                        </div>
                    </div>

                    <h5 className="fw-bold mb-3" style={{ color: "#202244", fontSize: "1.5rem" }}>
                        آفرین که تمرینت رو انجام دادی
                    </h5>

                    <div className="my-3 p-3 rounded-3" style={{ backgroundColor: "#E8F5E9", display: "inline-block" }}>
                        <span style={{ fontSize: "1.1rem", color: "#2E7D32" }}>
                            معلمت به زودی تمرینتو بررسی می‌کنه! به راهت ادامه بده
                        </span>
                    </div>

                    <p style={{ fontSize: "1rem", color: "#7e7e7e", maxWidth: "300px", margin: "0 auto" }}>
                        راهی که میری پر از ستاره‌ست! پس ادامه بده
                    </p>

                    <div className="mt-3">
                        <span role="img" aria-label="happy" style={{ fontSize: "1.5rem" }}>🎈</span>
                    </div>

                    <button
                        className="submit-exercise-btn px-5 mt-3"
                        onClick={closeSuccessModal}
                        style={{ backgroundColor: "#28a745", border: "none" }}
                    >
                        عالی! ادامه می‌دم 🚀
                    </button>
                </Modal.Body>
            </Modal>

            {/* مودال راهنمای تمرین */}
            <Modal
                show={showGuideModal}
                onHide={closeGuideModal}
                centered
            >
                <Modal.Body
                    className="p-4 text-center"
                    style={{ direction: "rtl" }}
                >
                    <div className="d-flex align-items-center justify-content-center mb-4">
                        <img src={eye} width={45} alt="" />
                        <div className="me-3 text-end">
                            <div>
                                برای دیدن یا دانلود فایل تمرین روی این آیکون کلیک کنید.
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-center mb-4">
                        <img src={upload2} width={45} alt="" />
                        <div className="me-3 text-end">
                            <div>
                                بعد از انجام تمرین، فایل یا پاسخ خود را از این قسمت ارسال کنید.
                            </div>
                        </div>
                    </div>

                    <Button
                        variant="success"
                        onClick={closeGuideModal}
                    >
                        متوجه شدم 👍
                    </Button>
                </Modal.Body>
            </Modal>

            {/* ========== دکمه خرید با نمایش قیمت ========== */}
            {courseDetail?.has_purchased === false && (
                <div className="payment-btn">
                    <button
                        className="submit-exercise-btn w-50 my-4 payment-container mx-auto"
                        onClick={handlePurchase}
                        disabled={purchasing}
                        style={{ padding: "15px 30px" }}
                    >
                        {purchasing ? (
                            <div className="d-flex align-items-center justify-content-center">
                                در حال ارتباط با درگاه پرداخت...
                            </div>
                        ) : (
                            <div className="d-flex flex-column align-items-center">
                                <div className="d-flex align-items-center">
                                    شروع ماجراجویی و خرید
                                    <svg className="mx-2" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                        <path d="M19 12H5M12 5L5 12L12 19" />
                                    </svg>
                                </div>
                                <div className="mt-1 d-flex align-items-center gap-2">
                                    <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                                        {courseDetail?.price === 0 || courseDetail?.price === null || courseDetail?.price === undefined ? 
                                            " رایگان" : 
                                            `${toPersianNumber(courseDetail.price)} تومان`
                                        }
                                    </span>
                                    {courseDetail?.price_without_discount && 
                                     courseDetail.price_without_discount !== courseDetail.price && 
                                     courseDetail?.price !== 0 && (
                                        <span style={{ 
                                            fontSize: "0.9rem", 
                                            textDecoration: "line-through", 
                                            color: "rgba(255,255,255,0.6)",
                                            marginRight: "8px"
                                        }}>
                                            {toPersianNumber(courseDetail.price_without_discount)} تومان
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </button>
                </div>
            )}

            {/* ====== دکمه تیکت پشتیبانی ====== */}
            {courseDetail?.has_purchased === true && (
                <TicketButton packageId={id} />
            )}
        </div>
    );
};

export default CourseDetail;